import Benefactor from "@/models/Sobrevivencia/Benefactor";
import moment from "moment";

function formatCedula(cedula: string): string {
  if (cedula && cedula.length === 11) {
    const prefix: string = cedula.substring(0, 3);
    const middle: string = cedula.substring(3, 10);
    const validador: string = cedula.substring(10);
    return `${prefix}-${middle}-${validador}`;
  } else {
    return "N/A";
  }
}

function formatFechaAfpSiembra(fecha: string): string {
  var localLocale = moment(fecha);
    moment.locale('es');
    localLocale.locale(false);  
  return localLocale.format("DD-MMM-YYYY");
}
function formatFechaActualizacionDatos(fecha: string): string {
  return moment(fecha).format("DD/MM/YYYY");
}

function setCookie(cname, cvalue): void {
  document.cookie = cname + "=" + cvalue + "; Path=/;";
}

function eraseCookie(name): void {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie =
    name + "=; Path=/portalbe; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function getCookie(cname): string {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function serializeValue(value: any): string {
  const stringifiedValue: string = JSON.stringify(value);
  const base64EncodedValue: string = btoa(stringifiedValue);
  return base64EncodedValue;
}
function reemplazarCaracteresEspeciales(str:string) {
  // Mapa de caracteres especiales con sus equivalentes
      let cleaned = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const reemplazos = {
    '"': '-',     // " (comillas dobles) -> -
    '¡': '-',     // ¡ (signo de exclamación invertido) -> -
    '¨': '-',     // ¨ (diéresis) -> -
    'ª': '-',     // ª (ordinal femenino) -> -
    '¬': '-',     // ¬ (símbolo de negación) -> -
    '°': '-',     // ° (símbolo de grados) -> -
    '´': '-',     // ´ (acento agudo) -> -
    '·': '-',     // · (punto medio) -> -
    'º': '-',     // º (ordinal masculino) -> -
    '¿': '-',     // ¿ (signo de interrogación invertido) -> -
    'Á': 'A',     // Á -> A
    'Ä': 'A',     // Ä -> A
    'Ç': 'C',     // Ç -> C
    'É': 'E',     // É -> E
    'Ë': 'E',     // Ë -> E
    'Í': 'I',     // Í -> I
    'Ï': 'I',     // Ï -> I
    'Ñ': 'N',     // Ñ -> N
    'Ó': 'O',     // Ó -> O
    'Ö': 'O',     // Ö -> O
    'Ú': 'U',     // Ú -> U
    'Ü': 'U',     // Ü -> U
    'á': 'a',     // á -> a
    'ä': 'a',     // ä -> a
    'ç': 'c',     // ç -> c
    'é': 'e',     // é -> e
    'ë': 'e',     // ë -> e
    'í': 'i',     // í -> i
    'ï': 'i',     // ï -> i
    'ñ': 'n',     // ñ -> n
    'ó': 'o',     // ó -> o
    'ö': 'o',     // ö -> o
    'ú': 'u',     // ú -> u
    'ü': 'u',     // ü -> u
    'À': 'A',     // À -> A
    'È': 'E',     // È -> E
    'Ì': 'i',     // Ì -> i
    'Ò': 'O',     // Ò -> O
    'Ù': 'U',     // Ù -> U
    'à': 'a',     // à -> a
    'è': 'e',     // è -> e
    'ì': 'i',     // ì -> i
    'ò': 'o',     // ò -> o
    'ù': 'u'      // ù -> u
  };

  
  return cleaned.split('').map(char => {
    return reemplazos[char] || char;   
  }).join('');
}

function deserializeValue(value: string): Object {
  if (value) {
    try {
      const decodedValue: string = atob(value);
      const obj: Object = JSON.parse(decodedValue);
      return obj;
    } catch (err) {
      console.error(err);
      return null;
    }
  } else {
    return null;
  }
}

const getBenefactorName = (benefactor: Benefactor) => {
  const namesToTest = [
    "primerNombre",
    "segundoNombre",
    "primerApellido",
    "segundoApellido",
  ];

  let benefactorName = "";

  namesToTest.forEach((name) => {
    if (benefactor[name]) {
      benefactorName += benefactor[name] + " ";
    }
  });

  return benefactorName;
};
const getRespBenefactorName = (benefactor: Benefactor) => {
  const namesToTest = [
    "primerNomResp",
    "segundoNomResp",
    "primerApeResp",
    "segundoApeResp",
  ];

  let benefactorName = "";

  namesToTest.forEach((name) => {
    if (benefactor[name]) {
      benefactorName += benefactor[name] + " ";
    }
  });

  return benefactorName;
};
export {
  formatCedula,
  formatFechaAfpSiembra,
  setCookie,
  eraseCookie,
  getCookie,
  serializeValue,
  deserializeValue,
  getBenefactorName,
  getRespBenefactorName,
  reemplazarCaracteresEspeciales
};
